import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { connect } from "react-redux";
import PaymentDescriptionTerms from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTerms";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import { isBookingDateEligibleForDeposit } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = state => {
	return {
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		onlinePercentage: getPartnerDepositPercentage(state),
	};
};

export default connect(mapStateToProps)(PaymentDescriptionTerms);
